// media-context.js
import React from "react";
import { MediaStream } from "../index-types";

const MediaContext = React.createContext<MediaStream | null>(null);

export default MediaContext;
